
export const QuestionFrontendIdentifiers = {
    languagePage: {
        languageTherapistQuestion: 'languageTherapistQuestion'
    },
    paymentSection: {
        feeTherapistQuestion: 'feeTherapistQuestion',
        insuranceplanTherapistQuestion: 'insuranceplanTherapistQuestion' 
    },
    clientAgeGroup: {
        clientAgeTherapistQuestion: 'clientAgeTherapistQuestion'
    },
    therapyLanguagePage: {
        therapyLanguageTherapistQuestion: 'therapyLanguageTherapistQuestion'
    }
};

export const sections: any = {
    bio: {
        pageIdentifier: "bioTherapistPg",
        questionIdentifier: ["bioTherapistQuestion"]
    }, bioScheduler: {
        pageIdentifier: "bioSchedulerPg",
        questionIdentifier: ["bioSchedulerQuestion"]
    }, bioPracticeAdmin: {
        pageIdentifier: "bioPracticeAdminPg",
        questionIdentifier: ["bioPracticeAdminQuestion"]
    }, basicSchedulerPhone: {
        pageIdentifier: "basicSchedulerPg",
        questionIdentifier: ["schedulerPhoneNumberQuestion"]
    }, basicPracticeAdminPhone: {
        pageIdentifier: "basicPracticeAdminPg",
        questionIdentifier: ["PracticeAdminPhoneNumberQuestion"]
    }, basicSchedulerEmail: {
        pageIdentifier: "basicSchedulerPg",
        questionIdentifier: ["schedulerPhoneNumberQuestion"]
    }, basicSchedulerLanguage: {
        pageIdentifier: "languageSchedulerPg",
        questionIdentifier: ["languageSchedulerQuestion"]
    }, basicPracticeAdminLanguage: {
        pageIdentifier: "languagePracticeAdminPg",
        questionIdentifier: ["languagePracticeAdminQuestion"]
    },
    serviceProvided: {
        pageIdentifier: "therapyProvideTherapistPg",
        questionIdentifier: ["therapySpecialiseTherapistQuestion"]
    },
    meetingPreferences: {
        pageIdentifier: "therapyMeetingPreferencesTherapistPg",
        questionIdentifier: ["therapyMeetingPreferencesTherapistQuestion"]
    },
    clientAgeGroup: {
        pageIdentifier: "clientAgeTherapistPg",
        questionIdentifier: ["clientAgeTherapistQuestion"]
    },
    paymentSection: {
        pageIdentifier: "therapistPaymentTherapistPg",
        questionIdentifier: [QuestionFrontendIdentifiers.paymentSection.feeTherapistQuestion, QuestionFrontendIdentifiers.paymentSection.insuranceplanTherapistQuestion]
    },
    languagePage: {
        pageIdentifier: "languageTherapistPg",
        questionIdentifier: [QuestionFrontendIdentifiers.languagePage.languageTherapistQuestion]
    },
    therapyLanguagePage: {
        pageIdentifier: "therapylanguageTherapistPg",
        questionIdentifier: [ QuestionFrontendIdentifiers.therapyLanguagePage.therapyLanguageTherapistQuestion]
    },
    therapyPracticeAddress: {
        pageIdentifier: "therapyPracticeAddressInformationPg",
        questionIdentifier: ["therapyPracticeAddressInformationPgV1"]
    },
    licenseTypeSection: {
        pageIdentifier: "licenseandcertificationTherapistPg",
        questionIdentifier: ["licensednumberTherapistQuestion", "licensedprovidertypeTherapistQuestion", "licensedstateTherapistQuestion"]
    },
    certificationSection: {
        pageIdentifier: "licenseandcertificationTherapistPg",
        questionIdentifier: ["cert1TherapistQuestion"]
    },
    educationalSection: {
        pageIdentifier: "therapistEducationalTherapistPg",
        questionIdentifier: ["yeargraduatedTherapistQuestion", "schoolgraduatedTherapistQuestion"]
    },
    availabilitySection: {
        pageIdentifier: "therapyCurrentAvailabilityTherapistPg",
        questionIdentifier: ["therapyCurrentAvailabilityTherapistQuestion"]
    },
    typeOfDegree: {
        pageIdentifier: "therapistEducationalTherapistPg",
        questionIdentifier: ["degreeTherapistQuestion"]
    },
    therapistConcerns: {
        pageIdentifier: "otherExpertiseTherapistpageFI",
        questionIdentifier: ["relationshipToSelfConcernTherapistQuestionFI", "relationshipToOtherConcernTherapistQuestionFI", "anxietyRelatedConcernTherapistQuestionFI", "moodConcernTherapistQuestionFI", "couplesFamilyConcernTherapistQuestionFI", "identityIssuesConcernTherapistQuestionV1", "performanceProductivityConcernTherapistQuestionFI", "difficultExperienceTertiaryConcernTherapistQuestionFI", "personalGrowthConcernTherapistQuestionFI", "problematicBehaviorConcernTherapistQuestionFI", "difficultLifeConcernTherapistQuestionFI", "neurologicalDisordersConcernTherapistQuestionFI"]
    },
    therapyTopSevenConcerns: {
        pageIdentifier: "topSevenExpertiseTherapistpageFI",
        questionIdentifier: ["topSevenExpertiseTherapistQuestionFI"]
    },
    therapyTopThreeConcerns: {
        pageIdentifier: "topThreeExpertiseTherapistpageFI",
        questionIdentifier: ["topThreeExpertiseTherapistQuestionFI"]
    },
    tertiaryTherapistModalities:{
        pageIdentifier: "tertiaryModalitiesTherapistPage",
        questionIdentifier: ["modalitiesTherapistQuestionFI"]
    },
    secondaryTherapistModalities:{
        pageIdentifier: "topThreeModalitiesTherapistPage",
        questionIdentifier: ["topThreeModalitiesTherapistQuestionFI"]
    },
    primaryTherapistModalities:{
        pageIdentifier: "primaryModalitiesTherapistPage",
        questionIdentifier: ["primaryModalitiesTherapistQuestionFI"]
    }
};

export const SectionChipsColors: any = {
    default: '#F0F2F8',
    insuranceplanTherapistQuestion: '#E8F6FF',
    otherExpertiseTherapistpageFI: '#FFEBF0',
    tertiaryModalitiesTherapistPage: '#FFF3D9',
    languageTherapistQuestion: '#F8E9FC',
    languageSchedulerQuestion: '#F8E9FC',
    languagePracticeAdminQuestion:'#F8E9FC',
    cert1TherapistQuestion: '#F0F3FA',
    clientAgeTherapistQuestion: '#E5F7EB'
};
